import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, RoleRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import LoginPage from "@/pages/Login";
import DashboardPage from "@/pages/Dashboard";
import BudgetRequestsPage from "@/pages/BudgetRequests";
import QuotationsPage from "@/pages/Quotations";
import PurchaseOrdersPage from "@/pages/PurchaseOrders";
import BillingRequestsPage from "@/pages/BillingRequests";
import ClientsPage from "@/pages/Clients";
import ClientDetailPage from "@/pages/ClientDetail";
import ReceivablesPage from "@/pages/Receivables";
import TrashPage from "@/pages/Trash";
import SuppliersPage from "@/pages/Suppliers";
import PermitsPage from "@/pages/Permits";
import ReportsPage from "@/pages/Reports";
import ClientReportsPage from "@/pages/ClientReports";
import BankReconciliationPage from "@/pages/BankReconciliation";
import VatSummaryPage from "@/pages/VatSummary";
import UsersPage from "@/pages/Users";
import AuditLogPage from "@/pages/AuditLog";
import ResetPasswordPage from "@/pages/ResetPassword";
import ChatPage from "@/pages/Chat";
import LiquidationsPage from "@/pages/Liquidations";
import TodosPage from "@/pages/Todos";
import InventoryPage from "@/pages/Inventory";
import AccountabilityPage from "@/pages/Accountability";
import CashPositionHistoryPage from "@/pages/CashPositionHistory";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route index element={<DashboardPage />} />
                    <Route path="budget-requests" element={<BudgetRequestsPage />} />
                    <Route path="quotations" element={<QuotationsPage />} />
                    <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
                    <Route path="billing-requests" element={<BillingRequestsPage />} />
                    <Route path="receivables" element={<RoleRoute roles={["finance", "procurement"]}><ReceivablesPage /></RoleRoute>} />
                    <Route path="trash" element={<RoleRoute roles={[]}><TrashPage /></RoleRoute>} />
                    <Route path="archived" element={<RoleRoute roles={[]}><TrashPage /></RoleRoute>} />
                    <Route path="clients" element={<ClientsPage />} />
                    <Route path="clients/:id" element={<ClientDetailPage />} />
                    <Route path="suppliers" element={<SuppliersPage />} />
                    <Route path="permits" element={<PermitsPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="client-reports" element={<RoleRoute roles={["finance", "procurement"]}><ClientReportsPage /></RoleRoute>} />
                    <Route path="bank-reconciliation" element={<RoleRoute roles={["finance"]}><BankReconciliationPage /></RoleRoute>} />
                    <Route path="vat-summary" element={<RoleRoute roles={["finance"]}><VatSummaryPage /></RoleRoute>} />
                    <Route path="chat" element={<ChatPage />} />
                    <Route path="chat/:channelId" element={<ChatPage />} />
                    <Route path="liquidations" element={<LiquidationsPage />} />
                    <Route path="cash-position" element={<RoleRoute roles={["finance"]}><CashPositionHistoryPage /></RoleRoute>} />
                    <Route path="todos" element={<TodosPage />} />
                    <Route path="inventory" element={<InventoryPage />} />
                    <Route path="accountability" element={<AccountabilityPage />} />
                    <Route path="users" element={<RoleRoute roles={[]}><UsersPage /></RoleRoute>} />
                    <Route path="audit-log" element={<RoleRoute roles={[]}><AuditLogPage /></RoleRoute>} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
